import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { PropertyType } from 'src/app/models/enums/property-type';
import { WorkflowState } from 'src/app/models/server/workflow-state';

@Component({
    selector: 'app-workflow-step',
    templateUrl: './workflow-step.component.html',
    styleUrls: ['./workflow-step.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatSelectModule, MatOptionModule]
})
export class WorkflowStepComponent {
    /**
     * Références des Enums utilisées dans le template.
     */
    public PropertyType = PropertyType;

    /**
     * Id de l'état courant de l'étape de workflow.
     */
    private _currentStateId: string;

    /**
     * Spécifie l'id de l'état courant de l'étape de workflow.
     */
    @Input()
    public set currentStateId(value: string) {
        this._currentStateId = value;
        this.determineCurrentStateName();
    }

    /**
     * Obtient l'id de l'état courant de l'étape de workflow.
     */
    public get currentStateId(): string {
        return this._currentStateId;
    }

    /**
     * Liste des états que peut prendre l'étape de workflow.
     */
    private _states: WorkflowState[];

    /**
     * Spécifile la liste des états que peut prendre l'étape de workflow.
     */
    @Input()
    public set states(value: WorkflowState[]) {
        this._states = value;
        this.determineCurrentStateName();
    }

    /**
     * Obtient la liste des états que peut prendre l'étape de workflow.
     */
    public get states(): WorkflowState[] {
        return this._states;
    }

    /**
     * Valeur indiquant si l'étape est terminée.
     */
    @Input()
    public completed: boolean;

    /**
     * Valeur indiquant si le composant est affiché en mode consultation.
     */
    @Input()
    public readonly: boolean;

    /**
     * Emis lorsque l'état de l'étape de workflow est mis à jour.
     */
    @Output()
    public stateUpdated: EventEmitter<number> = new EventEmitter();

    /**
     * Nom de l'état courant de l'étape de workflow.
     */
    public currentStateName: string;

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Appelée lorsque l'utilisateur sélectionne un nouvel état.
     * @param stateId : Id de l'état sélectionné.
     */
    public onUpdateState(stateId: number): void {
        this.stateUpdated.emit(stateId);
    }

    /**
     * Détermine le nom de l'état courant.
     */
    private determineCurrentStateName(): void {
        if (this.states && this.currentStateId && this.currentStateId !== 'N/A') {
            this.currentStateName = this.states.find((x) => x.id.toString() == this.currentStateId).name;
        }
    }
}
